<div class="modal-users h-full flex flex-col justify-between" *ngIf="translateModal?.buttonSave">
	<div
		class="modalHeader w-full pt-5 px-6 flex flex-row justify-between items-center border-b border-neutral-color-d"
	>
		<div class="titleNewModule">
			<span class="font-lato text-2xl font-semibold text-complementary-color-b">{{
				data.type === 'newUser'
					? translateModal.nameGroup + ' ' + data.group.name
					: data.type === 'updateUser'
					? translateModal.nameUpdateGroup + ' ' + data.group.name
					: data.type === 'updateGlobalUser'
					? translateModal.nameUpdate
					: translateModal.name
			}}</span>
		</div>
		<div class="closeModal pr-1">
			<mat-icon (click)="dialogRef.close()" class="cursor-pointer text-4xl">close</mat-icon>
		</div>
	</div>
	<div class="title h-[44px] tabs px-6 flex w-full justify-end">
		<div
			class="data cursor-pointer border-b-2 border-b-white flex items-center justify-center hover:bg-white hover:border-b-2 hover:border-b-primary-color px-4 h-[44px]"
			[ngClass]="{ 'border-b-2 bg-white !border-b-primary-color ': tab === '1' }"
			(click)="tab = '1'"
		>
			<span class="px-4 font-lato text-[14px] font-semibold">
				{{ translateModal.tabs.general }}
			</span>
		</div>
		<div
			class="data border-b-2 border-b-white cursor-pointer flex items-center justify-center hover:bg-white hover:border-b-2 hover:border-b-primary-color px-4 h-[44px]"
			[ngClass]="{ 'border-b-2 bg-white !border-b-primary-color ': tab === '2' }"
			(click)="tab = '2'"
			*ngIf="data.type === 'newUserGlobal' || data.type === 'updateGlobalUser'"
		>
			<span class="font-lato text-[14px] font-semibold px-4">
				{{ translateModal.tabs.groups }}
			</span>
		</div>
		<div
			class="data border-b-2 border-b-white cursor-pointer flex items-center justify-center hover:bg-white hover:border-b-2 hover:border-b-primary-color px-4 h-[44px]"
			[ngClass]="{ 'border-b-2 bg-white !border-b-primary-color ': tab === '3' }"
			(click)="tab = '3'"
		>
			<span class="font-lato text-[14px] font-semibold px-4">
				{{ translateModal.tabs.profile }}
			</span>
		</div>
	</div>
	<div class="body-users px-6 flex w-full h-full" [ngSwitch]="tab">
		<div class="form w-full h-full flex items-start" *ngSwitchCase="'1'">
			<form action="" [formGroup]="formUser" class="w-full">
				<div class="form-group">
					<label for="fullName">
						{{ translateModal.fullName }} <span class="asteriks">*</span></label
					>
					<input
						type="text"
						id="fullName"
						class="input-app"
						[placeholder]="translateModal.placeholderFullName"
						formControlName="fullName"
					/>
					<div *ngIf="f.fullName.touched && f.fullName.invalid" class="alert-error">
						<div *ngIf="f.fullName.errors?.required">{{ translateModal.fullnameRequired }}</div>
					</div>
				</div>

				<div class="form-group">
					<label for="username">
						{{ translateModal.username }} <span class="asteriks">*</span></label
					>
					<input
						type="text"
						id="username"
						class="input-app"
						(input)="validateUsername($event)"
						[placeholder]="translateModal.placeholderUsername"
						formControlName="username"
					/>
					<div *ngIf="f.username.touched && f.username.invalid" class="alert-error">
						<div *ngIf="f.username.errors?.required">{{ translateModal.usernameRequired }}</div>
					</div>
					<div *ngIf="stateUsername" class="alert-error">
						<div>{{ translateModal.usernameExists }}</div>
					</div>
				</div>
				<div class="form-group">
					<label for="email"> {{ translateModal.email }} <span class="asteriks">*</span></label>
					<input
						type="email"
						id="email"
						class="input-app"
						(input)="validateEmail($event)"
						[placeholder]="translateModal.placeholderEmail"
						formControlName="email"
					/>
					<div *ngIf="f.email.touched && f.email.invalid" class="alert-error">
						<div *ngIf="f.email.errors?.required">{{ translateModal.emailRequired }}</div>
						<div *ngIf="f.email.errors?.email">{{ translateModal.emailRequired }}</div>
					</div>
					<div *ngIf="stateEmail" class="alert-error">
						<div>{{ translateModal.emailExists }}</div>
					</div>
				</div>
				<div class="group-form w-full flex flex-row">
					<div
						class="form-group"
						[ngClass]="{
							'pr-2.5': data.type !== 'updateGlobalUser' && data.type !== 'newUserGlobal'
						}"
					>
						<label for="phone">{{ translateModal.phone }} </label>
						<ngx-intl-tel-input
							[cssClass]="'custom'"
							[preferredCountries]="preferredCountries"
							[enableAutoCountrySelect]="true"
							[enablePlaceholder]="true"
							[searchCountryFlag]="true"
							[searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
							[selectFirstCountry]="false"
							[selectedCountryISO]="selectedCountryISO"
							[phoneValidation]="true"
							(countryChange)="validatePhone($event)"
							(input)="validatePhone($event)"
							[separateDialCode]="separateDialCode"
							[numberFormat]="PhoneNumberFormat.International"
							name="phone"
							formControlName="phone"
							y
						>
						</ngx-intl-tel-input>
						<div *ngIf="f.phone.touched && f.phone.invalid" class="alert-error">
							<div *ngIf="f.phone.errors?.required">{{ translateModal.phoneRequired }}</div>
							<div
								*ngIf="
									!f.phone.errors?.validatePhoneNumber?.valid &&
									!f.phone.errors?.required &&
									!statePhone
								"
							>
								{{ translateModal.phoneValid }}
							</div>
						</div>
						<div *ngIf="statePhone" class="alert-error">
							<div>{{ translateModal.phoneExists }}</div>
						</div>
					</div>

					<div
						class="form-group pl-2.5"
						*ngIf="data.type != 'updateGlobalUser' && data.type != 'newUserGlobal'"
					>
						<label for="status"> {{ translateModal.status }} <span class="asteriks">*</span></label>
						<p-dropdown
							[options]="status"
							formControlName="status"
							class="w-full"
							[placeholder]="translateModal.placeholderStatus"
							optionLabel="name"
						>
							<ng-template let-status pTemplate="item" class="container-cardModule">
								<div class="status-item flex flex-row items-center">
									<div
										class="color w-5 h-2.5 rounded-2xl mx-2.5"
										[ngStyle]="{ background: status.color }"
									></div>
									<div class="font-lato">
										{{ status.name }}
									</div>
								</div>
							</ng-template>
						</p-dropdown>
						<div *ngIf="f.status.touched && f.status.invalid" class="alert-error">
							<div *ngIf="f.status.errors?.required">{{ translateModal.statusRequired }}</div>
						</div>
					</div>
				</div>
				<div class="passwords w-full flex flex-row">
					<div class="form-group pr-2.5">
						<label for="password">
							{{ translateModal.password }}
							<span
								class="asteriks"
								*ngIf="data.type !== 'updateGlobalUser' && data.type !== 'updateUser'"
								>*</span
							></label
						>
						<p-password
							[placeholder]="translateModal.placeholderPassword"
							id="password"
							formControlName="password"
							[toggleMask]="true"
							[feedback]="false"
							[mediumRegex]="
								'^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{4,})'
							"
						></p-password>
						<div *ngIf="f.password.touched && f.password.invalid" class="alert-error">
							<div *ngIf="f.password.errors?.required">{{ translateModal.passwordRequired }}</div>
						</div>
					</div>
					<div class="form-group pl-2.5">
						<label for="confirmPassword">
							{{ translateModal.confirmPassword }}
							<span
								class="asteriks"
								*ngIf="data.type !== 'updateGlobalUser' && data.type !== 'updateUser'"
								>*</span
							></label
						>
						<p-password
							[placeholder]="translateModal.placeholderConfirmPassword"
							id="confirmPassword"
							formControlName="confirmPassword"
							[toggleMask]="true"
							[feedback]="false"
							[mediumRegex]="
								'^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{4,})'
							"
						>
						</p-password>
						<div *ngIf="f.confirmPassword.touched && f.confirmPassword.invalid" class="alert-error">
							<div *ngIf="f.confirmPassword.errors?.required">
								{{ translateModal.confirmPasswordRequired }}
							</div>
							<div *ngIf="f.confirmPassword.errors?.confirmedValidator">
								{{ translateModal.confirmPasswordNotMatch }}
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
		<div *ngSwitchCase="'2'" class="w-full">
			<div class="form-group">
				<label for="phone"> {{ translateModal.groups }} </label>
				<ng-select
					[(ngModel)]="groupsSelected"
					[multiple]="true"
					[clearable]="false"
					placeholder="Groups"
					(change)="validateGroups()"
					class="custom-dropdown"
					bindLabel="name"
				>
					<ng-option *ngFor="let group of groups" [value]="group">
						<div class="flex justify-between">
							<span>
								{{ group.name }}
							</span>
							<div class="flex items-center gap-1">
								<mat-icon
									class="text-complementary-color-a material-icons-outlined text-[20px] !h-[20px] !w-[20px]"
									>store</mat-icon
								>
								<span class="text-xs">
									{{ group.clientName }}
									Client
								</span>
							</div>
						</div>
					</ng-option>
				</ng-select>
			</div>
			<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
				<!-- This is the tree node template for leaf nodes -->
				<mat-tree-node
					class="border-b border-b-[#e7e7e7]"
					*matTreeNodeDef="let node"
					matTreeNodePadding
				>
					<!-- use a disabled button to provide padding for tree leaf -->
					<button mat-icon-button disabled></button>
					{{ node.name?.name }}
				</mat-tree-node>
				<!-- This is the tree node template for expandable nodes -->
				<mat-tree-node
					class="border-b border-b-[#e7e7e7] flex justify-between"
					*matTreeNodeDef="let node; when: hasChild"
					matTreeNodePadding
				>
					<div class="flex items-center">
						<button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
							<mat-icon class="mat-icon-rtl-mirror text-primary-color">
								{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
							</mat-icon>
						</button>
						<div class="flex items-center">
							<span *ngIf="node.name.roles" class="mr-1"> Status:</span>
							<span *ngIf="node.name.resources" class="mr-1"> Role: </span>
							<div>
								<div *ngIf="node.name.roles" class="relative">
									<div>
										<app-dropdown-status
											[node]="node.name"
											[elements]="node.name.statusUser"
											(elementSelected)="elementSelected($event, node.name.resp)"
										></app-dropdown-status>
									</div>
								</div>
								<span *ngIf="!node.name.roles">
									{{ node.name?.name }}
								</span>
							</div>
						</div>
					</div>
					<div class="flex items-center gap-1" *ngIf="node.name.clientName">
						<mat-icon
							class="text-complementary-color-a material-icons-outlined text-[20px] !h-[20px] !w-[20px]"
							>store</mat-icon
						>
						<span class="text-xs"> {{ node.name.clientName }} </span>
					</div>
				</mat-tree-node>
			</mat-tree>
		</div>
		<div *ngSwitchCase="'3'" class="w-full h-full">
			<div class="flex flex-col w-full pt-3 h-full" [formGroup]="formProfile">
				<div class="w-full flex items-center justify-between">
					<span class="text-sm font-semibold font-lato text-[#121529]">
						{{ translateModal.headerKey }} </span
					><span class="text-sm font-semibold font-lato text-[#121529]"
						>{{ translateModal.headerValue }}
					</span>
				</div>
				<div class="h-[calc(100%-20px)] overflow-y-auto overflow-x-hidden flex flex-col gap-2 mt-2">
					<ng-container formArrayName="profile">
						<div
							class="modal-service__content__item"
							*ngFor="let item of fields.controls; let index = index"
							[formGroupName]="index"
						>
							<input
								type="text"
								[placeholder]="translateModal.placeholderKey"
								class="modal-service__content__item__name"
								formControlName="key"
							/>
							<input
								type="text"
								[placeholder]="translateModal.placeholderValue"
								class="modal-service__content__item__cost"
								formControlName="value"
							/>
							<mat-icon *ngIf="fields.controls.length !== 1" (click)="removeField(index)">
								delete
							</mat-icon>
						</div>
					</ng-container>

					<div class="w-full flex justify-end items-center h-auto pt-3">
						<button
							class="mg-button primaryButton buttonAdd flex items-center justify-center gap-2"
							(click)="addField()"
						>
							<mat-icon>add</mat-icon>
							<span> {{ translateModal.buttonAdd }} </span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="footer-modal modalAction">
		<button (click)="dialogRef.close()" class="mg-button secundaryButton mr-3">
			{{ translateModal.buttonCancel }}
		</button>
		<button
			(click)="save()"
			class="mg-button primaryButton"
			[disabled]="
				formUser.invalid || stateUsername || stateEmail || statePhone || formProfile.invalid
			"
		>
			{{ translateModal.buttonSave }}
		</button>
	</div>
</div>
